import { createPluginRequest } from '@capital/common';

export const request = createPluginRequest('com.msgbyte.iam');
